import { useState, useEffect, useRef, Suspense, lazy } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import Burger from '../../components/Nav/Burger.jsx';

// Reusing your styled components for visual consistency
const FullSite = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  width: 100vw;
  cursor: default;
`;

const ContainerNavBar = styled.div`
  z-index: 50;
  display: grid;
  grid-template-rows: repeat(1, 1fr);
  position: fixed;
  justify-items: center;
  top: 0;
  right: 0;
  height: 0;
  width: 50vw;
  justify-self: stretch;

  @media screen and (min-width: 0px) and (max-width: 480px) {
    width: 100vw;
    grid-template-columns: 1rem 1rem auto 1rem 80px;
  }
  @media screen and (min-width: 481px) and (max-width: 768px) {
    width: 100vw;
    grid-template-columns: 2.5rem 1vw auto 1vw 100px;
  }
  @media screen and (min-width: 769px) {
    grid-template-columns: 2.5vw 1vw auto 1vw 120px;
  }
`;

// Section 5 is your Footer
const Section4 = lazy(() => import('../Home/Section_4'));
const Section5 = lazy(() => import('../Home/Footer'));
const Teams = lazy(() => import('../Home/Teams'));

function About() {
  const full = useRef(null);

  // We assume the loader has already run since they navigated here
  const loaderRuned = useSelector((state) => state.loaderRuned.value);

  return (
    <>
      <meta
        name="Nod Studio - About"
        content="Architects Developers EstudioNod"
      />
      <FullSite ref={full} className="FullSite" id="FullSite">
        <Suspense fallback={<div>Loading...</div>}>
          {/* 1. Burger Menu (Nav) */}
          <ContainerNavBar id="boton">
            <Burger />
          </ContainerNavBar>

          <Teams />
          <Section4 />

          {/* 3. Footer (Section 5) */}
          <Section5 />
        </Suspense>
      </FullSite>
    </>
  );
}

export default About;
